import { c as _c } from "react/compiler-runtime";
import { SignInButton as SignInButtonClerk, SignOutButton as SignOutButtonClerk, Show } from "@clerk/nextjs";
import { useQuery } from "@tanstack/react-query";
import type { ComponentProps, ReactNode } from "react";
import { Button } from "@/components/ui/button";
import type { ButtonProps } from "@/components/ui/button";
import { currentUserQueryOptions } from "@/lib/auth/react-queries";
import { hasEdraMembership, isOrgAdmin } from "./shared";
const SignOutButton = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SignOutButtonClerk redirectUrl="/sign-in" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Button asChild={true} {...props}>{t0}</Button>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const SignInButton = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SignInButtonClerk />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Button asChild={true} {...props}>{t0}</Button>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const SignedIn = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Show when="signed-in">{children}</Show>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const SignedOut = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Show when="signed-out">{children}</Show>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export { UserButton, SignIn, SignUp } from "@clerk/nextjs";
export function useHasEdraOrg() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = currentUserQueryOptions();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data
  } = useQuery(t0);
  let t1;
  if ($[1] !== data) {
    t1 = data ? hasEdraMembership(data) : false;
    $[1] = data;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function useIsOrgAdmin() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = currentUserQueryOptions();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data
  } = useQuery(t0);
  let t1;
  if ($[1] !== data) {
    t1 = data ? isOrgAdmin(data) : false;
    $[1] = data;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export { SignedIn, SignedOut, SignInButton, SignOutButton };
export function usePermissions() {
  const $ = _c(2);
  const isAdmin = useIsOrgAdmin();
  let t0;
  if ($[0] !== isAdmin) {
    t0 = {
      canEdit: isAdmin,
      canManageReviewSla: isAdmin,
      canSeeSharedInbox: isAdmin
    };
    $[0] = isAdmin;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}